export enum CardType {
    NONE = 'NONE',
    AMEX = 'AMEX',
    DINERSINT = 'DINERSINT',
    DISCOVER = 'DISCOVER',
    JCB = 'JCB',
    MAESTRO = 'MAESTRO',
    MASTERCARD = 'MASTERCARD',
    VISA = 'VISA'
}